// react components
import React from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// pages
import {
    ErrorHelper825,
    FormLabel825,
} from 'pages'

// serializer
import {
    TranslationHelper,
} from 'serializers/site'

// props
type TextInputV2825Props = {
    directionRtl?: boolean
    disabled?: boolean
    error?: string
    helperText?: string
    label?: string
    max?: string
    min?: string
    name: string
    onChange: any
    onKeyPress?: any
    onRefresh?: () => void
    pattern?: string
    placeholder?: string
    step?: string
    tabIndex?: number
    translation?: TranslationHelper
    type?: 'number' | 'time' | 'text' | 'tel' | 'url' | 'email' | 'search' | 'date' | 'password'
    value: string | number
    zeroForEmpty?: boolean
}

// main
export const TextInputV2825: React.FC<TextInputV2825Props> = React.forwardRef((
    {
        directionRtl,
        disabled,
        error,
        helperText,
        label,
        max,
        min,
        name,
        onChange,
        onKeyPress,
        onRefresh,
        pattern,
        placeholder,
        step,
        tabIndex,
        translation,
        type,
        value,
        zeroForEmpty,
    },
    ref: React.Ref<HTMLInputElement>
) => {

    const dispatch = useDispatch()
    const reduxAuth = useSelector((state: defaultReduxState) => state.reduxAuth)

    function onInputChange(targetValue: string | null | undefined) {
        try {
            if (zeroForEmpty && targetValue === '') {
                onChange({
                    name: name,
                    value: 0,
                })
            } else {
                onChange({
                    name: name,
                    value: targetValue,
                })
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TextInputV2825',
                'onInputChange',
            ))
        }
    }

    if (label || translation) {
        return (
            <div className={`input-wrap-825${disabled ? ' disabled' : ''}`}>
                <div className='input-label-wrap'>
                    <FormLabel825
                        formInput='text'
                        helperText={helperText}
                        label={label || ''}
                        name={name}
                        onRefresh={onRefresh}
                        translation={translation}
                        translationDefaultValue={value}
                    />
                </div>
                <input
                    className={`text-input-825${directionRtl ? ' rtl' : ''}`}
                    disabled={disabled}
                    max={max}
                    min={min}
                    name={name}
                    onChange={(e) => onInputChange(e.target.value)}
                    onKeyPress={onKeyPress}
                    pattern={pattern}
                    placeholder={placeholder}
                    ref={ref}
                    step={step}
                    tabIndex={tabIndex}
                    type={type}
                    value={value}
                />
                <ErrorHelper825 error={error} />
            </div>
        )
    }

    return (
        <input
            className={`text-input-825${directionRtl ? ' rtl' : ''}`}
            disabled={disabled}
            max={max}
            min={min}
            name={name}
            onChange={(e) => onInputChange(e.target.value)}
            onKeyPress={onKeyPress}
            pattern={pattern}
            placeholder={placeholder}
            ref={ref}
            step={step}
            tabIndex={tabIndex}
            type={type}
            value={value}
        />
    )
})
